<template>
  <div class="input-group">
    <div class="awesomplete">
      <Input
        type="text"
        prefix="ios-plane"
        v-model="city"
        @on-blur="handleBlur()"
        :placeholder="inputholder"
        required
        @input="handleCityInput()"
      />
      <ul v-if="citySelect">
        <li
          is="select-item"
          v-for="(item, index) in cities"
          v-bind:key="index"
          v-bind:itemCode="item.code4"
          v-bind:itemText="item.airport"
          @on-click-select="handleClickSelect"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { queryAirport } from '@/api/net-api'
import Vue from 'vue'

Vue.component('select-item', {
  template: '\
    <li aria-selected="selected" value="itemCode" @click="handleClick" >\
        {{itemText}} \
    </li>\
  ',
  props: ['itemText', 'itemCode'],
  data () {
    return {
      selected: false
    }
  },
  methods: {
    handleClick: function () {
      this.$emit('on-click-select', { text: this.itemText, code: this.itemCode })
    }
  }
})
export default {
  name: 'CityInput',
  props: ['inputholder'],
  data () {
    return {
      city: '',
      code: '',
      citySelect: false,
      cities: [],
      loadedData: false,
      cancelAjax: null
    }
  },
  methods: {
    handleCityInput: function () {
      if (typeof this.cancelAjax === 'function') {
        this.cancelAjax()
      }
      this.cities = []
      this.citySelect = false
      if (this.city.length === 0) {
        this.loadedData = false
        return
      }
      // this.loading(true)
      /* queryAirport({ 'q': this.city })
        .then(res => {
          console.log('airport:' + res.data)
          this.loadedData = false
          this.citySelect = true
          if (res.data != null) {
            this.cities = res.data
          } else {
            this.code = ''
          }
        })
        .catch(err => {
          // this.loading(false)
          console.log(err)
          this.loadedData = true
          this.code = ''
        })
    }, */
      queryAirport({ 'q': this.city }, this)
        .then(res => {
          if (res.status === 200) {
            this.loadedData = false
            this.citySelect = true
            if (res.data != null) {
              this.cities = res.data
            } else {
              this.code = ''
            }
          } else {
            console.log('queryAirport error.')
          }
        })
        .catch(err => {
          // this.loading(false)
          this.loadedData = true
          this.code = ''
        })
    },
    handleClickSelect: function ({ text, code }) {
      this.citySelect = false
      this.city = text
      this.code = code
    },
    handleBlur: function () {
      setTimeout(() => {
        this.citySelect = false
      }, 200)
    }
  }
}
</script>
<style scoped>
@import "../assets/styles/app.css";
</style>


// WEBPACK FOOTER //
// src/components/city-input.vue